import InputMask from 'react-input-mask';

import { GDMInputMaskComponent } from './GDMInputMask.type';

/* TODO: Implement component using GDM default design */
const GDMInputMask: GDMInputMaskComponent = props => <InputMask {...props} />;

export default GDMInputMask;
